export const CLAIMS_SOLUTION_FORM_NAME = 'claims_solution';
export const CLAIMS_REJECT_FORM_NAME = 'claims_reject';
export const CLAIMS_DOCUMENTS_FORM_NAME = 'claims_documents';

export const REQUIRED_FIELDS = ['solution'];

export const REQUEST_ERROR_MESSAGE = 'Заполните это поле';
